
import { Color, colorNewFromRGBA, colorNewFromRGBA8 } from "../Color.js";
import {
    BackgroundConstructor,
    BgBonus,
    BgIce,
    BgJungle,
    BgMaster,
    BgNight,
    BgSand,
    BgSpace,
    BgStorm,
    BgSunset,
    BgWater,
} from "./Background.js";

export enum StageId {
    St001_Plain = 1,
    St002_Diamond = 2,
    St003_Hairpin = 3,
    St004_Wide_Bridge = 4,
    St005_Slopes = 5,
    St006_Steps = 6,
    St007_Blocks = 7,
    St008_Jump_Single = 8,
    St009_Exam_A = 9,
    St010_Arcade_Spiral_Hard = 10,
    St011_Bump = 11,
    St012_Walking = 12,
    St013_Repulse = 13,
    St014_Narrow_Bridge = 14,
    St015_Break = 15,
    St016_Curves = 16,
    St017_Downhill = 17,
    St018_Blocks_Slim = 18,
    St019_Arcade_Diamond = 19,
    St020_Arcade_Tracks = 20,
    St021_Choice = 21,
    St022_Bowl = 22,
    St023_Jumpies = 23,
    St024_Stoppers = 24,
    St025_Floor_Bent = 25,
    St026_Conveyor = 26,
    St027_Exam_B = 27,
    St028_Chaser = 28,
    St029_Jump_Double = 29,
    St030_Arcade_Bridge_Master = 30,
    St031_Middle_Jam = 31,
    St032_Antlion = 32,
    St033_Collapse = 33,
    St034_Swing_Bar = 34,
    St035_Labyrinth = 35,
    St036_Spiral = 36,
    St037_Wavy_Jump = 37,
    St038_Spiky = 38,
    St039_Unrest = 39,
    St040_Polar = 40,
    St041_Ruin = 41,
    St042_Branch = 42,
    St043_Overturn = 43,
    St044_Excursion = 44,
    St045_Dodecagon = 45,
    St046_Exam_C = 46,
    St047_Skeleton = 47,
    St048_Tracks = 48,
    St049_Arcade_Narrow_Bridge = 49,
    St050_Arcade_Curl_Pipe = 50,
    St051_Downhill_Hard = 51,
    St052_Gears = 52,
    St053_Destruction = 53,
    St054_Invasion = 54,
    St055_Diving = 55,
    St056_Floor_Slant = 56,
    St057_Tram = 57,
    St058_Swing_Bar_Long = 58,
    St059_Paperwork = 59,
    St060_Arcade_Sanctuary = 60,
    St061_Twin_Attacker = 61,
    St062_Sega_Logo = 62,
    St063_Snake = 63,
    St064_Wind = 64,
    St065_Windy_Slide = 65,
    St066_Fall_Down = 66,
    St067_Twin_Cross = 67,
    St068_Spiral_Hard = 68,
    St069_Conveyor_Parts = 69,
    St070_Arcade_Hitter = 70,
    St071_Gaps = 71,
    St072_Curvature = 72,
    St073_Ant_Lion_Super = 73,
    St074_Drum = 74,
    St075_Twist_And_Spin = 75,
    St076_Speedy_Jam = 76,
    St077_Quake = 77,
    St078_Cassiopeia = 78,
    St079_Pirates = 79,
    St080_Arcade_Av_Logo = 80,
    St081_Bowl_Open = 81,
    St082_Checker = 82,
    St083_Carpet = 83,
    St084_Ridge = 84,
    St085_Mixer = 85,
    St086_Rings = 86,
    St087_Stairs = 87,
    St088_Clover = 88,
    St089_Coffee_Cup = 89,
    St090_Metamorphasis = 90,
    St091_Bonus_Basic = 91,
    St092_Bonus_Wave = 92,
    St093_Bonus_Grid = 93,
    St094_Bonus_Bumpy = 94,
    St095_Bonus_Hunting = 95,
    St096_Arcade_Snake = 96,
    St097_Arcade_Gears = 97,
    St098_Arcade_Conveyer_Parts = 98,
    St099_Jungle_Bg = 99,
    St100_Arcade_Polar_Large = 100,
    St101_Blur_Bridge = 101,
    St102_Hitter = 102,
    St103_Av_Logo = 103,
    St104_Hard_Hitter = 104,
    St105_Puzzle = 105,
    St106_Polar_Large = 106,
    St107_Breathe = 107,
    St108_Ferris_Wheel = 108,
    St109_Factory = 109,
    St110_Curl_Pipe = 110,
    St111_Magic_Hand = 111,
    St112_Sanctuary = 112,
    St113_Daa_Loo_Maa = 113,
    St114_Unused_Rings_Stage = 114,
    St115_Alternate_Edge_Master = 115,
    St116_Alternate_Roll_Master = 116,
    St117_Arcade_Curves = 117,
    St118_Arcade_Jump_Double = 118,
    St119_Arcade_Downhill_Hard = 119,
    St120_Arcade_Dodecagon = 120,
    St121_Wave_Master = 121,
    St122_Fan_Master = 122,
    St123_Stamina_Master = 123,
    St124_Spring_Master = 124,
    St125_Dance_Master = 125,
    St126_Roll_Master = 126,
    St127_Edge_Master = 127,
    St128_Dodge_Master = 128,
    St129_Bridge_Master = 129,
    St130_Monkey_Master = 130,
    St131_Race_Space = 131,
    St132_Race_Unused = 132,
    St133_Race_Jungle = 133,
    St134_Race_Ice = 134,
    St135_Race_Downtown = 135,
    St136_Race_Water = 136,
    St137_Chaser_Duplicate = 137,
    St138_Race_Desert = 138,
    St139_Exam_A_Broken = 139,
    St140_Av_Logo_Broken = 140,
    St141_Yellow_Square = 141,
    St142_Water_Test = 142,
    St143_Fight_Jungle = 143,
    St144_Fight_Ice = 144,
    St145_Fight_Space = 145,
    St150_Tutorial = 150,
    St151_Target_Circles = 151,
    St152_Target_Pyramids = 152,
    St153_Target_Hexagons = 153,
    St154_Target_Unuseds = 154,
    St155_Monkey_Target_Bg = 155,
    St161_Golf_Hole_18 = 161,
    St162_Golf_Hole_4 = 162,
    St163_Golf_Hole_6 = 163,
    St164_Golf_Hole_3 = 164,
    St165_Golf_Hole_5 = 165,
    St166_Golf_Hole_15 = 166,
    St167_Golf_Hole_1 = 167,
    St168_Golf_Hole_8 = 168,
    St169_Golf_Hole_10 = 169,
    St170_Golf_Hole_14 = 170,
    St171_Golf_Hole_16 = 171,
    St172_Golf_Hole_7 = 172,
    St173_Golf_Hole_12 = 173,
    St174_Golf_Hole_17 = 174,
    St175_Golf_Hole_9 = 175,
    St176_Golf_Hole_13 = 176,
    St177_Golf_Hole_2 = 177,
    St178_Golf_Hole_11 = 178,
    St179_Bowling = 179,
    St180_Billiards = 180,
    St197_Bonus_Bg = 197,
    St198_Ending_Cutscene_Bg = 198,
}

export enum BgType {
    BlueSky = 1,
    Jungle = 13,
    Water = 14,
    Night = 15,
    Sunset = 16,
    Space = 17,
    Sand = 18,
    Ice = 19,
    Storm = 20,
    Bonus = 21,
    Target = 22,
    Billiards = 23,
    Golf = 24,
    Bowling = 25,
    Master = 26,
    Ending = 27,
}

export type BgInfo = {
    fileName: string;
    clearColor: Color;
    bgConstructor: BackgroundConstructor;

    ambientColor: Color;
    // Global directional light ("infinite" light)
    infLightColor: Color;
    infLightRotX: number;
    infLightRotY: number;
};

export type StageInfo = {
    id: StageId;
    bgInfo: BgInfo;
    // TODO(complexplane): Next stage
};

export namespace BgInfos {
    export const Jungle: BgInfo = {
        fileName: "bg_jun",
        clearColor: colorNewFromRGBA8(0xffffffff),
        bgConstructor: BgJungle,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Water: BgInfo = {
        fileName: "bg_wat",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgWater,
        ambientColor: colorNewFromRGBA(0.28, 0.48, 0.63),
        infLightColor: colorNewFromRGBA(0.6, 0.85, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Night: BgInfo = {
        fileName: "bg_nig",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgNight,
        ambientColor: colorNewFromRGBA(0.4, 0.4, 0.7),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Sunset: BgInfo = {
        fileName: "bg_sun",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgSunset,
        ambientColor: colorNewFromRGBA(0.4, 0.4, 0.7),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Space: BgInfo = {
        fileName: "bg_spa",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgSpace,
        ambientColor: colorNewFromRGBA(0.5, 0.45, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 29184,
        infLightRotY: 17664,
    };
    export const Sand: BgInfo = {
        fileName: "bg_snd",
        clearColor: colorNewFromRGBA8(0xd8bc77ff),
        bgConstructor: BgSand,
        ambientColor: colorNewFromRGBA(0.45, 0.4, 0.25),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 24576,
        infLightRotY: 24576,
    };
    export const Ice: BgInfo = {
        fileName: "bg_ice",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgIce,
        ambientColor: colorNewFromRGBA(0.55, 0.6, 0.85),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Storm: BgInfo = {
        fileName: "bg_stm",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgStorm,
        ambientColor: colorNewFromRGBA(0.3, 0.3, 0.45),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Bonus: BgInfo = {
        fileName: "bg_bns",
        clearColor: colorNewFromRGBA8(0x000000ff),
        bgConstructor: BgBonus,
        ambientColor: colorNewFromRGBA(0.6, 0.7, 0.8),
        infLightColor: colorNewFromRGBA(0.8, 0.8, 0.8),
        infLightRotX: -11776,
        infLightRotY: 21888,
    };
    export const Target: BgInfo = {
        fileName: "bg_pil",
        clearColor: colorNewFromRGBA8(0xffffffff),
        bgConstructor: {} as any,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Golf: BgInfo = {
        fileName: "bg_gol",
        clearColor: colorNewFromRGBA8(0xffffffff),
        bgConstructor: {} as any,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Bowling: BgInfo = {
        fileName: "bg_bow",
        clearColor: colorNewFromRGBA8(0xffffffff),
        bgConstructor: {} as any,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Master: BgInfo = {
        fileName: "bg_mst",
        clearColor: colorNewFromRGBA8(0xffffcdff),
        bgConstructor: BgMaster,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
    export const Ending: BgInfo = {
        fileName: "bg_ending",
        clearColor: colorNewFromRGBA8(0xffffffff),
        bgConstructor: {} as any,
        ambientColor: colorNewFromRGBA(0.6, 0.6, 0.6),
        infLightColor: colorNewFromRGBA(1, 1, 1),
        infLightRotX: 8192,
        infLightRotY: 24576,
    };
}

const STAGE_LIST: StageInfo[] = [
    { id: StageId.St001_Plain, bgInfo: BgInfos.Jungle },
    { id: StageId.St002_Diamond, bgInfo: BgInfos.Jungle },
    { id: StageId.St003_Hairpin, bgInfo: BgInfos.Jungle },
    { id: StageId.St004_Wide_Bridge, bgInfo: BgInfos.Jungle },
    { id: StageId.St005_Slopes, bgInfo: BgInfos.Sunset },
    { id: StageId.St006_Steps, bgInfo: BgInfos.Sunset },
    { id: StageId.St007_Blocks, bgInfo: BgInfos.Sunset },
    { id: StageId.St008_Jump_Single, bgInfo: BgInfos.Sunset },
    { id: StageId.St009_Exam_A, bgInfo: BgInfos.Sunset },
    { id: StageId.St011_Bump, bgInfo: BgInfos.Jungle },
    { id: StageId.St012_Walking, bgInfo: BgInfos.Jungle },
    { id: StageId.St013_Repulse, bgInfo: BgInfos.Jungle },
    { id: StageId.St014_Narrow_Bridge, bgInfo: BgInfos.Jungle },
    { id: StageId.St015_Break, bgInfo: BgInfos.Sunset },
    { id: StageId.St016_Curves, bgInfo: BgInfos.Sunset },
    { id: StageId.St017_Downhill, bgInfo: BgInfos.Sunset },
    { id: StageId.St018_Blocks_Slim, bgInfo: BgInfos.Sunset },
    { id: StageId.St021_Choice, bgInfo: BgInfos.Night },
    { id: StageId.St022_Bowl, bgInfo: BgInfos.Night },
    { id: StageId.St023_Jumpies, bgInfo: BgInfos.Night },
    { id: StageId.St024_Stoppers, bgInfo: BgInfos.Night },
    { id: StageId.St025_Floor_Bent, bgInfo: BgInfos.Night },
    { id: StageId.St026_Conveyor, bgInfo: BgInfos.Night },
    { id: StageId.St027_Exam_B, bgInfo: BgInfos.Night },
    { id: StageId.St028_Chaser, bgInfo: BgInfos.Night },
    { id: StageId.St029_Jump_Double, bgInfo: BgInfos.Night },
    { id: StageId.St031_Middle_Jam, bgInfo: BgInfos.Water },
    { id: StageId.St032_Antlion, bgInfo: BgInfos.Water },
    { id: StageId.St033_Collapse, bgInfo: BgInfos.Water },
    { id: StageId.St034_Swing_Bar, bgInfo: BgInfos.Water },
    { id: StageId.St035_Labyrinth, bgInfo: BgInfos.Water },
    { id: StageId.St036_Spiral, bgInfo: BgInfos.Water },
    { id: StageId.St037_Wavy_Jump, bgInfo: BgInfos.Water },
    { id: StageId.St038_Spiky, bgInfo: BgInfos.Water },
    { id: StageId.St039_Unrest, bgInfo: BgInfos.Water },
    { id: StageId.St040_Polar, bgInfo: BgInfos.Water },
    { id: StageId.St041_Ruin, bgInfo: BgInfos.Jungle },
    { id: StageId.St042_Branch, bgInfo: BgInfos.Jungle },
    { id: StageId.St043_Overturn, bgInfo: BgInfos.Jungle },
    { id: StageId.St044_Excursion, bgInfo: BgInfos.Jungle },
    { id: StageId.St045_Dodecagon, bgInfo: BgInfos.Night },
    { id: StageId.St046_Exam_C, bgInfo: BgInfos.Night },
    { id: StageId.St047_Skeleton, bgInfo: BgInfos.Night },
    { id: StageId.St048_Tracks, bgInfo: BgInfos.Night },
    { id: StageId.St051_Downhill_Hard, bgInfo: BgInfos.Water },
    { id: StageId.St052_Gears, bgInfo: BgInfos.Water },
    { id: StageId.St053_Destruction, bgInfo: BgInfos.Water },
    { id: StageId.St054_Invasion, bgInfo: BgInfos.Water },
    { id: StageId.St055_Diving, bgInfo: BgInfos.Water },
    { id: StageId.St056_Floor_Slant, bgInfo: BgInfos.Water },
    { id: StageId.St057_Tram, bgInfo: BgInfos.Water },
    { id: StageId.St058_Swing_Bar_Long, bgInfo: BgInfos.Water },
    { id: StageId.St059_Paperwork, bgInfo: BgInfos.Water },
    { id: StageId.St061_Twin_Attacker, bgInfo: BgInfos.Sand },
    { id: StageId.St062_Sega_Logo, bgInfo: BgInfos.Sand },
    { id: StageId.St063_Snake, bgInfo: BgInfos.Sand },
    { id: StageId.St064_Wind, bgInfo: BgInfos.Sand },
    { id: StageId.St065_Windy_Slide, bgInfo: BgInfos.Sand },
    { id: StageId.St066_Fall_Down, bgInfo: BgInfos.Sand },
    { id: StageId.St067_Twin_Cross, bgInfo: BgInfos.Sand },
    { id: StageId.St068_Spiral_Hard, bgInfo: BgInfos.Sand },
    { id: StageId.St069_Conveyor_Parts, bgInfo: BgInfos.Sand },
    { id: StageId.St071_Gaps, bgInfo: BgInfos.Ice },
    { id: StageId.St072_Curvature, bgInfo: BgInfos.Ice },
    { id: StageId.St073_Ant_Lion_Super, bgInfo: BgInfos.Ice },
    { id: StageId.St074_Drum, bgInfo: BgInfos.Ice },
    { id: StageId.St075_Twist_And_Spin, bgInfo: BgInfos.Ice },
    { id: StageId.St076_Speedy_Jam, bgInfo: BgInfos.Ice },
    { id: StageId.St077_Quake, bgInfo: BgInfos.Ice },
    { id: StageId.St078_Cassiopeia, bgInfo: BgInfos.Ice },
    { id: StageId.St079_Pirates, bgInfo: BgInfos.Ice },
    { id: StageId.St081_Bowl_Open, bgInfo: BgInfos.Storm },
    { id: StageId.St082_Checker, bgInfo: BgInfos.Storm },
    { id: StageId.St083_Carpet, bgInfo: BgInfos.Storm },
    { id: StageId.St084_Ridge, bgInfo: BgInfos.Storm },
    { id: StageId.St085_Mixer, bgInfo: BgInfos.Storm },
    { id: StageId.St086_Rings, bgInfo: BgInfos.Storm },
    { id: StageId.St087_Stairs, bgInfo: BgInfos.Storm },
    { id: StageId.St088_Clover, bgInfo: BgInfos.Storm },
    { id: StageId.St089_Coffee_Cup, bgInfo: BgInfos.Storm },
    { id: StageId.St090_Metamorphasis, bgInfo: BgInfos.Storm },
    { id: StageId.St091_Bonus_Basic, bgInfo: BgInfos.Bonus },
    { id: StageId.St092_Bonus_Wave, bgInfo: BgInfos.Bonus },
    { id: StageId.St093_Bonus_Grid, bgInfo: BgInfos.Bonus },
    { id: StageId.St094_Bonus_Bumpy, bgInfo: BgInfos.Bonus },
    { id: StageId.St095_Bonus_Hunting, bgInfo: BgInfos.Bonus },
    { id: StageId.St099_Jungle_Bg, bgInfo: BgInfos.Jungle },
    { id: StageId.St101_Blur_Bridge, bgInfo: BgInfos.Space },
    { id: StageId.St102_Hitter, bgInfo: BgInfos.Space },
    { id: StageId.St103_Av_Logo, bgInfo: BgInfos.Space },
    { id: StageId.St104_Hard_Hitter, bgInfo: BgInfos.Space },
    { id: StageId.St105_Puzzle, bgInfo: BgInfos.Space },
    { id: StageId.St106_Polar_Large, bgInfo: BgInfos.Space },
    { id: StageId.St107_Breathe, bgInfo: BgInfos.Space },
    { id: StageId.St108_Ferris_Wheel, bgInfo: BgInfos.Space },
    { id: StageId.St109_Factory, bgInfo: BgInfos.Space },
    { id: StageId.St110_Curl_Pipe, bgInfo: BgInfos.Space },
    { id: StageId.St111_Magic_Hand, bgInfo: BgInfos.Space },
    { id: StageId.St112_Sanctuary, bgInfo: BgInfos.Space },
    { id: StageId.St113_Daa_Loo_Maa, bgInfo: BgInfos.Space },
    { id: StageId.St115_Alternate_Edge_Master, bgInfo: BgInfos.Master },
    { id: StageId.St116_Alternate_Roll_Master, bgInfo: BgInfos.Master },
    { id: StageId.St117_Arcade_Curves, bgInfo: BgInfos.Master },
    { id: StageId.St118_Arcade_Jump_Double, bgInfo: BgInfos.Master },
    { id: StageId.St119_Arcade_Downhill_Hard, bgInfo: BgInfos.Master },
    { id: StageId.St120_Arcade_Dodecagon, bgInfo: BgInfos.Master },
    { id: StageId.St121_Wave_Master, bgInfo: BgInfos.Master },
    { id: StageId.St122_Fan_Master, bgInfo: BgInfos.Master },
    { id: StageId.St123_Stamina_Master, bgInfo: BgInfos.Master },
    { id: StageId.St124_Spring_Master, bgInfo: BgInfos.Master },
    { id: StageId.St125_Dance_Master, bgInfo: BgInfos.Master },
    { id: StageId.St126_Roll_Master, bgInfo: BgInfos.Master },
    { id: StageId.St127_Edge_Master, bgInfo: BgInfos.Master },
    { id: StageId.St128_Dodge_Master, bgInfo: BgInfos.Master },
    { id: StageId.St129_Bridge_Master, bgInfo: BgInfos.Master },
    { id: StageId.St130_Monkey_Master, bgInfo: BgInfos.Master },
    { id: StageId.St131_Race_Space, bgInfo: BgInfos.Space },
    { id: StageId.St132_Race_Unused, bgInfo: BgInfos.Sand },
    { id: StageId.St133_Race_Jungle, bgInfo: BgInfos.Jungle },
    { id: StageId.St134_Race_Ice, bgInfo: BgInfos.Ice },
    { id: StageId.St135_Race_Downtown, bgInfo: BgInfos.Night },
    { id: StageId.St136_Race_Water, bgInfo: BgInfos.Water },
    { id: StageId.St137_Chaser_Duplicate, bgInfo: BgInfos.Night },
    { id: StageId.St138_Race_Desert, bgInfo: BgInfos.Sand },
    { id: StageId.St139_Exam_A_Broken, bgInfo: BgInfos.Sunset },
    { id: StageId.St140_Av_Logo_Broken, bgInfo: BgInfos.Space },
    { id: StageId.St141_Yellow_Square, bgInfo: BgInfos.Space },
    { id: StageId.St142_Water_Test, bgInfo: BgInfos.Water },
    { id: StageId.St143_Fight_Jungle, bgInfo: BgInfos.Jungle },
    { id: StageId.St144_Fight_Ice, bgInfo: BgInfos.Ice },
    { id: StageId.St145_Fight_Space, bgInfo: BgInfos.Space },
    { id: StageId.St150_Tutorial, bgInfo: BgInfos.Jungle },
    { id: StageId.St151_Target_Circles, bgInfo: BgInfos.Target },
    { id: StageId.St152_Target_Pyramids, bgInfo: BgInfos.Target },
    { id: StageId.St153_Target_Hexagons, bgInfo: BgInfos.Target },
    { id: StageId.St154_Target_Unuseds, bgInfo: BgInfos.Target },
    { id: StageId.St155_Monkey_Target_Bg, bgInfo: BgInfos.Target },
    { id: StageId.St161_Golf_Hole_18, bgInfo: BgInfos.Jungle },
    { id: StageId.St162_Golf_Hole_4, bgInfo: BgInfos.Jungle },
    { id: StageId.St163_Golf_Hole_6, bgInfo: BgInfos.Jungle },
    { id: StageId.St164_Golf_Hole_3, bgInfo: BgInfos.Jungle },
    { id: StageId.St165_Golf_Hole_5, bgInfo: BgInfos.Jungle },
    { id: StageId.St166_Golf_Hole_15, bgInfo: BgInfos.Jungle },
    { id: StageId.St167_Golf_Hole_1, bgInfo: BgInfos.Jungle },
    { id: StageId.St168_Golf_Hole_8, bgInfo: BgInfos.Jungle },
    { id: StageId.St169_Golf_Hole_10, bgInfo: BgInfos.Jungle },
    { id: StageId.St170_Golf_Hole_14, bgInfo: BgInfos.Jungle },
    { id: StageId.St171_Golf_Hole_16, bgInfo: BgInfos.Jungle },
    { id: StageId.St172_Golf_Hole_7, bgInfo: BgInfos.Jungle },
    { id: StageId.St173_Golf_Hole_12, bgInfo: BgInfos.Jungle },
    { id: StageId.St174_Golf_Hole_17, bgInfo: BgInfos.Jungle },
    { id: StageId.St175_Golf_Hole_9, bgInfo: BgInfos.Jungle },
    { id: StageId.St176_Golf_Hole_13, bgInfo: BgInfos.Jungle },
    { id: StageId.St177_Golf_Hole_2, bgInfo: BgInfos.Jungle },
    { id: StageId.St178_Golf_Hole_11, bgInfo: BgInfos.Jungle },
    { id: StageId.St179_Bowling, bgInfo: BgInfos.Bowling },
    { id: StageId.St197_Bonus_Bg, bgInfo: BgInfos.Bonus },
    { id: StageId.St198_Ending_Cutscene_Bg, bgInfo: BgInfos.Ending },
];

export const STAGE_INFO_MAP: Map<StageId, StageInfo> = new Map(
    STAGE_LIST.map((stageInfo) => [stageInfo.id, stageInfo])
);
